var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNewWindow)?_c('a',{staticClass:"app-link",class:[_vm.fontColor],attrs:{"href":_vm.path,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1):_c('router-link',{staticClass:"app-link",class:[_vm.fontColor],attrs:{"to":_vm.path}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }